var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_22_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#EDF2F8",
    points: "41,15 41,1 9,1 9,63 55,63 55,15  "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_23"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "41,1 41,15 55,15  "
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "icon_8_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#8592A5",
    d: "M55.994,14.989c-0.009-0.237-0.098-0.474-0.279-0.655 L41.666,0.285c-0.179-0.179-0.411-0.267-0.646-0.277C41.014,0.006,41,0,41,0H10C8.896,0,8,0.896,8,2v60c0,1.104,0.896,2,2,2h44 c1.104,0,2-0.896,2-2V15C56,15,55.995,14.991,55.994,14.989z M42,3.381L52.619,14C48.477,14,42,14,42,14S42,7.524,42,3.381z  M54,62H33V38h1c1.104,0,2-0.896,2-2v-8c0-1.104-0.896-2-2-2v-2h-2v2h-2c-1.104,0-2,0.896-2,2v8c0,1.104,0.896,2,2,2h1v24H10V2h20 v2h2V2h8v14h14V62z M34,32v4h-4v-4H34z M30,30v-2h4v2H30z M34,6V4h-2v2H34z M30,8h2V6h-2V8z M34,10V8h-2v2H34z M30,12h2v-2h-2V12z  M34,14v-2h-2v2H34z M30,16h2v-2h-2V16z M34,18v-2h-2v2H34z M30,20h2v-2h-2V20z M34,22v-2h-2v2H34z M30,22v2h2v-2H30z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/_zip.d19a8ac2e0ad381fff53f51cb659e72c.svg";
export { ForwardRef as ReactComponent };